import { withHydrate } from '@relay/react/hooks';
import Bleach from '@img/icons/care/bleach.svg';
import Chemical from '@img/icons/care/chemical.svg';
import GentleDrying from '@img/icons/care/gentaldrying.svg';
import Iron from '@img/icons/care/iron.svg';
import Tumbler from '@img/icons/care/tumbler.svg';
import FourtyDegrees from '@img/icons/care/wash40.svg';
import React from 'react';
import { CareIconsStyles as s } from './CareIcons.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let Icon = /*#__PURE__*/function (Icon) {
  Icon[Icon["Chemical"] = 1] = "Chemical";
  Icon[Icon["Iron"] = 2] = "Iron";
  Icon[Icon["Bleach"] = 3] = "Bleach";
  Icon[Icon["Tumbler"] = 4] = "Tumbler";
  Icon[Icon["FourtyDegrees"] = 5] = "FourtyDegrees";
  Icon[Icon["GentleDrying"] = 6] = "GentleDrying";
  return Icon;
}({});
const renderIcon = icon => {
  switch (icon) {
    case Icon.Chemical:
      {
        return /*#__PURE__*/_jsx(Chemical, {});
      }
    case Icon.Iron:
      {
        return /*#__PURE__*/_jsx(Iron, {});
      }
    case Icon.Bleach:
      {
        return /*#__PURE__*/_jsx(Bleach, {});
      }
    case Icon.Tumbler:
      {
        return /*#__PURE__*/_jsx(Tumbler, {});
      }
    case Icon.FourtyDegrees:
      {
        return /*#__PURE__*/_jsx(FourtyDegrees, {});
      }
    case Icon.GentleDrying:
      {
        return /*#__PURE__*/_jsx(GentleDrying, {});
      }
  }
};
const CareIcons = ({
  translations,
  icons
}) => {
  return /*#__PURE__*/_jsx(s.Wrapper, {
    children: /*#__PURE__*/_jsxs(s.Container, {
      children: [translations['custom.productdetail.careicon.title'] && /*#__PURE__*/_jsx(s.TitleContainer, {
        children: /*#__PURE__*/_jsx(s.Title, {
          children: translations['custom.productdetail.careicon.title']
        })
      }), /*#__PURE__*/_jsx(s.IconsContainer, {
        children: icons && icons.map(item => /*#__PURE__*/_jsxs(s.Icon, {
          children: [/*#__PURE__*/_jsx(s.IconImageContainer, {
            children: renderIcon(item.icon)
          }), item.title && /*#__PURE__*/_jsx(s.IconTitle, {
            children: item.title
          })]
        }, item.title))
      })]
    })
  });
};
export default withHydrate(CareIcons, 'CareIcons', 'hybrid');
